import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function ChooseAdventure() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-sand-light relative z-20 -mt-10 rounded-t-[3rem] shadow-[0_-20px_40px_rgba(0,0,0,0.1)]" data-id="element-39">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-40">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-41">
          {/* Rainforest Card */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="group relative rounded-3xl overflow-hidden shadow-2xl bg-white" data-id="element-42">
            <div className="h-64 sm:h-80 overflow-hidden relative" data-id="element-43">
              <img src="https://cdn.magicpatterns.com/uploads/fDWRYDuPXFdmht4Kx9GQ1Z/ChatGPT_Image_15_jun_2026,_04_07_55_p.m..png" alt="Sweet and Salty Puerto Rico Adventures" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-44" />
              <div className="absolute inset-0 bg-gradient-to-t from-rainforest-dark/70 to-transparent" data-id="element-45" />
            </div>
            <div className="p-8" data-id="element-46">
              <ul className="space-y-3 mb-8" data-id="element-47">
                {t.chooseAdventure.rainforestFeatures.map((feature, idx) => <li key={idx} className="flex items-center gap-3 text-gray-700" data-id="element-48">
                    <CheckCircle2 className="text-rainforest w-5 h-5 flex-shrink-0" data-id="element-49" />
                    <span data-id="element-50">{feature}</span>
                  </li>)}
              </ul>
              <a href="#rainforest" className="inline-flex items-center gap-2 text-rainforest font-bold hover:text-rainforest-light transition-colors group/btn" data-id="element-51">
                {t.chooseAdventure.rainforestCta}
                <ArrowRight className="w-5 h-5 transition-transform group-hover/btn:translate-x-1" data-id="element-52" />
              </a>
            </div>
          </motion.div>

          {/* Boat Card */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="group relative rounded-3xl overflow-hidden shadow-2xl bg-white" data-id="element-53">
            <div className="h-64 sm:h-80 overflow-hidden relative" data-id="element-54">
              <img src="https://images.unsplash.com/photo-1540202404-b71180f24e93?q=80&w=1000&auto=format&fit=crop" alt="" aria-hidden="true" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-55" />
              <div className="absolute inset-0 bg-gradient-to-t from-ocean-dark/90 to-transparent" data-id="element-56" />
              <img src="https://cdn.magicpatterns.com/uploads/aifgHKgDB7GaFaemiHaRod/LOGO_PNG_ORIGI.png" alt="Blu Ocean Tours" className="absolute inset-0 m-auto h-44 sm:h-52 w-auto object-contain drop-shadow-[0_8px_30px_rgba(0,180,216,0.4)]" data-id="element-57" />
            </div>
            <div className="p-8" data-id="element-58">
              <ul className="space-y-3 mb-8" data-id="element-59">
                {t.chooseAdventure.boatFeatures.map((feature, idx) => <li key={idx} className="flex items-center gap-3 text-gray-700" data-id="element-60">
                    <CheckCircle2 className="text-turquoise w-5 h-5 flex-shrink-0" data-id="element-61" />
                    <span data-id="element-62">{feature}</span>
                  </li>)}
              </ul>
              <a href="#boat" className="inline-flex items-center gap-2 text-ocean font-bold hover:text-ocean-light transition-colors group/btn" data-id="element-63">
                {t.chooseAdventure.boatCta}
                <ArrowRight className="w-5 h-5 transition-transform group-hover/btn:translate-x-1" data-id="element-64" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}